export enum GraphUnit {
  'number',
  'currency',
  'frequency',
}
